module.exports = require("./../../_gen/starling/assets/AssetFactory");